// extracted by mini-css-extract-plugin
export var actionButton = "_ds-0";
export var attachmentLine = "_ds-1";
export var fileInput = "_ds-2";
export var fileUploadWrapper = "_ds-4";
export var footer = "_ds-3";
export var modalContent = "_ds-5";
export var paperclip = "_ds-6";
export var quillEditor = "_ds-7";